import { useStore } from "#src/stores/Store.tsx";
import { BetaAccessType } from "#types/code-generator.ts";

export function AscaLive() {
  const store = useStore();

  const showLiveAd = store.organization.betaAccess.includes(
    BetaAccessType.Meets
  );

  if (!showLiveAd) {
    return null;
  }

  return (
    <div className="flex items-center rounded-md bg-[#153161] px-6 py-6 text-white sm:flex-col sm:gap-6">
      <div className="flex-1">
        <a href="https://www.youtube.com/@captynapp" target="_blank">
          <img
            src="/img/asca/business-of-swimming.png"
            alt="Business of Swimming"
            width={240}
          />
        </a>
      </div>

      <div className="bg-main h-36 w-1 rounded sm:h-1 sm:w-36" />

      <div className="flex-[1.5] text-center">
        <div className="bg-error mb-2 inline-block rounded-md px-2 font-bold uppercase">
          • Live Now
        </div>

        <h1 className="text-4xl font-bold">
          2026 ASCA
          <br />
          World Clinic
        </h1>

        <p className="mb-1 text-white">
          Captyn is streaming live from the Rosen Center in Orlando, Florida, at
          the ASCA World Clinic.
        </p>
        <p className="mb-0 px-6 text-white">
          We’re putting some of swimming’s most interesting people in the Hot
          Seat.
        </p>
      </div>

      <div className="bg-main h-36 w-1 rounded sm:h-1 sm:w-36" />

      <div className="flex-1 text-center">
        <div className="mb-2 text-white">
          <strong>Watch the stream now!</strong>
        </div>

        <a
          href="https://www.youtube.com/@captynapp"
          target="_blank"
          className="mb-2 block"
        >
          <img
            src="/img/asca/asca-youtube.png"
            alt="Watch on YouTube"
            width={191}
          />
        </a>

        <a
          href="https://www.facebook.com/captynapp/"
          target="_blank"
          className="block"
        >
          <img
            src="/img/asca/asca-facebook.png"
            alt="Watch on Facebook"
            width={191}
          />
        </a>
      </div>
    </div>
  );
}
